<template>
  <el-dialog
    title="收款二维码"
    :visible.sync="dialogVisible"
    width="400px"
    center
    @close="handleClose"
  >
    <div style="text-align: center;">
      <div ref="qrcodeRef" style="display: inline-block; padding: 20px;" />
      <p style="margin-top: 10px; word-break: break-all; font-size: 12px; color: #666;">
        {{ qrCodeUrl }}
      </p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">关 闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getShopQrCode } from '@/api/phone/shopQrCodeApi'
import QRCode from 'qrcodejs2'

export default {
  name: 'QrCodeDialog',
  data() {
    return {
      dialogVisible: false,
      qrCodeUrl: ''
    }
  },
  methods: {
    async open(row) {
      this.dialogVisible = true
      this.$nextTick(async () => {
        try {
          const res = await getShopQrCode({ qrId: row.qrId })
          if (res.code === 0) {
            this.qrCodeUrl = res.data.qrCode
            this._generateQrCode(res.data.qrCode)
          } else {
            this.$message.error('获取二维码信息失败')
          }
        } catch (error) {
          console.error('获取二维码信息失败:', error)
        }
      })
    },
    _generateQrCode(url) {
      this.$nextTick(() => {
        const el = this.$refs.qrcodeRef
        if (!el) return
        el.innerHTML = ''
        new QRCode(el, {
          text: url,
          width: 200,
          height: 200,
          colorDark: '#000',
          colorLight: '#fff',
          correctLevel: QRCode.CorrectLevel.H
        })
      })
    },
    handleClose() {
      this.qrCodeUrl = ''
      const el = this.$refs.qrcodeRef
      if (el) el.innerHTML = ''
    }
  }
}
</script>
